import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities } from 'redux-modules/entity'

import api from 'api'

const FETCH_REQUEST = 'realhub/pricingPlan/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/pricingPlan/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/pricingPlan/FETCH_FAILURE'

const CREATE_REQUEST = 'realhub/pricingPlan/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/pricingPlan/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/pricingPlan/CREATE_FAILURE'

const UPDATE_REQUEST = 'realhub/pricingPlan/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/pricingPlan/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/pricingPlan/UPDATE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  loaded: false,
  loading: false,
  updating: false,
  errors: [],
}

// Action
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(){
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function loadPricingPlans(options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('/admin/pricing_plans.json', options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.PRICING_PLAN_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function createPricingPlan(pricingPlan, options, callback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      pricing_plan: pricingPlan,
    }),
  }

  return (dispatch) => {
    dispatch(createRequest())

    const promise = api('/admin/pricing_plans.json', options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.PRICING_PLAN)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

export function updatePricingPlan(pricingPlan, options, callback){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      pricing_plan: pricingPlan,
    }),
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const promise = api(`/admin/pricing_plans/${pricingPlan.id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.PRICING_PLAN)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return { ...state, loading: true }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors,
      }
    case CREATE_REQUEST:
      return { ...state, creating: true }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors: action.errors,
      }
    case UPDATE_REQUEST:
      return { ...state, updating: true }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
